<template>
  <div class="chart-wrap" v-loading="loading">
    <div class="">
      <echart
        v-if="!loading"
        chartId="dashboard-trend"
        :height="height / 2"
        :options="today"
        :not-merge="notMerge"
      >
      </echart>

      <div
        v-else-if="loading"
        v-loading="loading"
        class="no-data"
        :style="`height: ${height / 2}px;`"
      >
        <span>加载中……</span>
      </div>

      <div v-else class="no-data" :style="`height: ${height / 2}px;`">
        <span>暂无数据</span>
      </div>
    </div>

    <div class="">
      <echart
        v-if="!loading"
        chartId="dashboard-trend-today"
        :height="height / 2"
        :options="month"
        :not-merge="notMerge"
      >
      </echart>

      <div
        v-else-if="loading"
        v-loading="loading"
        class="no-data"
        :style="`height: ${height / 2}px;`"
      >
        <span>加载中……</span>
      </div>

      <div v-else class="no-data" :style="`height: ${height / 2}px;`">
        <span>暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/components/Chart'
import merge from 'lodash.merge'

const FONT_SIZE = 14 // 内边距、默认字体大小

export default {
  components: { Echart },
  props: {
    loading: Boolean,
    actived: [Number, String],
    deviceId: [Number, String],
    trends: {
      type: Array,
      required: true
    },
    trendsToday: {
      type: Array,
      required: true
    },
    notMerge: { type: Boolean, default: false }
  },
  data() {
    return {
      height: 240,
      defaultOption: {
        toolbox: { show: false },
        title: {
          show: true,
          x: 'center',
          text: 'test',
          top: 4,
          textStyle: { fontSize: FONT_SIZE, color: '#000' }
        },
        tooltip: { trigger: 'axis', confine: true },
        grid: {
          top: 60,
          bottom: 60
        },
        xAxis: { type: 'time', boundaryGap: false },
        yAxis: { type: 'value' }
      }
    }
  },
  mounted() {
    this.height = this.$el.offsetHeight
  },
  computed: {
    legend() {
      let selected = {}
      const legend = this.trends.map(t => t.category)
      legend.forEach(
        l => (selected[l] = this.actived ? l === this.actived : true)
      )
      return {
        top: 28,
        left: 36,
        itemWidth: 16,
        itemHeight: 10,
        textStyle: { fontSize: FONT_SIZE },
        selected: selected
      }
    },
    dataZoom() {
      return [
        {
          show: true,
          top: this.height / 2 - 48,
          bottom: 24,
          left: 86,
          right: 80
        }
      ]
    },
    month() {
      return merge({}, this.defaultOption, {
        title: { text: '15天变化趋势' },
        legend: this.legend,
        dataZoom: this.dataZoom,
        series: this.trends.map(t => {
          return {
            type: 'line',
            name: t.category,
            smooth: true,
            data: t.data.map(d => {
              const device = d.devices.find(dd => +dd.id === +this.deviceId)
              return device ? [d.date].concat(device.qty) : []
            })
          }
        })
      })
    },
    today() {
      return merge({}, this.defaultOption, {
        title: { text: '24小时变化趋势' },
        legend: this.legend,
        dataZoom: this.dataZoom,
        series: this.trendsToday.map(c => {
          return {
            type: 'line',
            name: c.category,
            smooth: true,
            smoothMonotone: 'x',
            data: c.data.map(d => [d.date, d.qty])
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.dashbord-trend {
  height: calc(100% - 53px);
}
.dashboard-trend__title {
  padding: 14px 1rem;
  font-size: 1.1rem;
  font-weight: 400;
  background-color: #f2f6fc;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
</style>
